import React from "react";
import { history } from "../../helper/history";
import Form from "../common/form/Form";
import Spinner from "../common/Spinner";
import { routes } from "../../helper/routes";

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clickLogin: false,
      loading: false,
    };
  }

  handleRoleSelect = (role) => {
    sessionStorage.setItem("user_role_selection", role);
    history.push(routes.auth_response);
  };

  render() {
    return (
      <div className="teacher-login-form">
        {this.state.loading && <Spinner id="show" text="Logging In..." />}

        <Form className="teacher-login-form-inner" id="kt_login_singin_form">
          <button
            type="button"
            onClick={() => this.handleRoleSelect("teacher")}
            className="teacher-signin-btn"
          >
            Sign-In
          </button>
        </Form>
      </div>
    );
  }
}

export default LoginForm;
